module.exports = __webpack_public_path__ + "img/27_50.d91f0580.png";